class NumbercardController {
    constructor() {
        this.icon = 'fa-check';
        this.title = '';
        this.value = 0;
        this.percentageOfParentValue = 0;
    }
}
angular.module('app').component('numbercard', {
    bindings: {
        icon: '@',
        title: '@',
        value: '<',
        percentageOfParentValue: '<'
    },
    templateUrl: 'scripts/app/partials/Capacity/numbercard.tpl.html',
    controllerAs: 'vm',
    controller: NumbercardController
});
